import { useNavigate } from "react-router-dom";

export default function AdminSidebar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("admin_access_token");
        navigate("/admin/login");
    };

    return (
        <div className="bg-gray-900 text-white w-64 p-6 min-h-screen">
            <h2 className="text-xl font-bold">Admin Panel</h2>
            <nav className="mt-6">
                <ul className="space-y-3">
                    <li><a href="/admin/dashboard" className="block py-2 px-3 rounded hover:bg-gray-800">🏠 Dashboard</a>
                    </li>
                    <li><a href="/admin/restaurants" className="block py-2 px-3 rounded hover:bg-gray-800">🍽️ Manage
                        Restaurants</a></li>
                    <li><a href="/admin/subscriptions" className="block py-2 px-3 rounded hover:bg-gray-800">💳 Manage
                        Subscriptions</a></li>
                    <li>
                        <a href="/admin/newsletter" className="block py-2 px-3 rounded hover:bg-gray-800">
                            📨 Newsletter
                        </a>
                    </li>
                    <li>
                        <a href="/admin/chat-limit" className="block py-2 px-3 rounded hover:bg-gray-800">
                            🧮 Chat Limit Settings
                        </a>
                    </li>
                    <li>
                        <a href="/admin/chat-resets" className="block py-2 px-3 rounded hover:bg-gray-800">
                            🧾 Chat Reset History
                        </a>
                    </li>
                    <li>
                        <button
                            onClick={handleLogout}
                            className="block w-full py-2 px-3 rounded bg-red-600 hover:brightness-110 text-white font-semibold transition duration-200"
                        >
                            🚪 Logout
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
}
